import { Component, Vue, PropSync } from 'vue-property-decorator';
import { LoggerService } from '@/utils';
import { ShareFilterData } from '@/models/filter/ShareFilterData';
import { DexieFilter } from '@/models/dexie/DexieFilter';
import { FilterNewService } from '@/services/index';

@Component
export default class ShareFilter extends Vue {
    @PropSync('shared', { type: Boolean }) public share!: boolean;
    @PropSync('filter', { type: Object }) public synchedFilter!: DexieFilter;

    public emails: string = '';
    public emailsToSend: string[] = [];
    public filterName: string = '';
    public isValid: boolean = true;
    public errorMessage: string = '';

    // tslint:disable-next-line: no-empty
    public mounted() {
        this.filterName = this.synchedFilter ? this.synchedFilter.filterName : '';
    }

    public async onShare() {
        this.emails = this.emails.split(' ').join('');
        this.emailsToSend = this.emails.split(',');
        if (this.validate()) {
            if (this.synchedFilter !== undefined) {
                this.filterName = this.synchedFilter.filterName;
                const shareFilter = new ShareFilterData();
                shareFilter.filterId = this.synchedFilter.filterUuid;
                shareFilter.emails = this.emailsToSend;
                FilterNewService.ShareFilter(shareFilter)
                    .then((response) => {
                        LoggerService.debug(`Filter shared: `, response);
                    })
                    .catch((error) => {
                        LoggerService.error(`Error on share filter: `, error);
                    });
            }
            this.$emit('close');
        } else {
            this.isValid = false;
            this.errorMessage = 'Invalid Email, please enter again!';
        }
    }

    private validate() {
        let valid: boolean = false;
        const re = /^(([^<>()[\]\\.;:\s@\"]+(\.[^<>()[\]\\.;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        this.emailsToSend.forEach((email) => {
            valid = re.test(email) ? true : false;
        });
        return valid;
    }
}
